import { SettingsService } from './../../_services/settings.service';
import { Component, OnInit, ViewChild, TemplateRef, Input, Output, EventEmitter } from '@angular/core';
import { FormGroup, FormBuilder, FormControl, Validators, AbstractControl } from '@angular/forms';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { LocalStorageService } from 'src/app/_services/local-storage.service';

@Component({
  selector: 'app-edit-call-log-settings',
  templateUrl: './edit-call-log-settings.component.html',
  styleUrls: ['./edit-call-log-settings.component.scss']
})
export class EditCallLogSettingsComponent implements OnInit {

  addOrEditCallLog: FormGroup;
  newOutcome: any;
  error_message: string = null;
  success_message: string = null;
  @Input() editoutcome: any
  @Output() passEntry: EventEmitter<any> = new EventEmitter();
  
  constructor(private modalService: NgbModal, private fb: FormBuilder, private settingservice: SettingsService,
    private _localstorageservice : LocalStorageService) { }

  ngOnInit() {
    this.addOrEditCallLog = this.fb.group({
      newOutcome: [this.editoutcome != null ? this.editoutcome.outcometext : '',[Validators.required,noWhitespaceValidator]],
      newOutcomeType: [this.editoutcome != null ? this.editoutcome.outcometype : null, Validators.required],
    })

    function noWhitespaceValidator(control: AbstractControl) {
      const isWhitespace = (control.value || '').trim().length === 0;
      const isValid = !isWhitespace;
      return isValid ? null : { 'required': true };
  }
  }
  dismiss() {
    this.modalService.dismissAll();
  }

  addNewCallOutcome() {
    if (this.addOrEditCallLog.valid) {
      if (this.editoutcome == null) {
        let data = {
          "outcometext": `'${this.addOrEditCallLog.get('newOutcome').value}'`,
          "outcometype": `'${this.addOrEditCallLog.get('newOutcomeType').value}'`,
          "createdby": this._localstorageservice.getItem('usernumber')
        }
        this.settingservice.createOutcome(data).subscribe((res: any) => {
          if (res.status == 'success') {
            this.modalService.dismissAll();
            this.passEntry.emit('added');
          }else {
            this.modalService.dismissAll();
            this.passEntry.emit('error');
          }
        })
      } else {
        let data = {
          "editDetails": {
            "outcometext": `'${this.addOrEditCallLog.get('newOutcome').value}'`,
            "outcometype": `'${this.addOrEditCallLog.get('newOutcomeType').value}'`,
            "updatedby": this._localstorageservice.getItem('userid')
          },
          "outcomeid": this.editoutcome.outcomeid
        }
        this.settingservice.editOutcome(data).subscribe((res: any) => {
          if (res.status == 'success') {
            this.modalService.dismissAll();
            this.passEntry.emit('modify');
          }else {
            this.modalService.dismissAll();
            this.passEntry.emit('error');
          }
        })
      }
    } else {
      this.validateAllFormFields(this.addOrEditCallLog)
    }
  }

  validateAllFormFields(formGroup: FormGroup) { 
    Object.keys(formGroup.controls).forEach(field => {
      const control = formGroup.get(field);
      if (control instanceof FormControl) {
        control.markAsTouched({ onlySelf: true });
      } else if (control instanceof FormGroup) {
        this.validateAllFormFields(control);
      }
    });
  }

}
